import axios from "axios";
import Vue from "vue";
import dict from "./dict";
import pageDict from "./pageDict";
import store from "../store";
import moment from "moment";
import invokeNative from "./invokeNative";
import getPageLevelMixin from "./getPageLevelMixin";
import config from "./config";
import webSocket from "./webSocket";
import serverApi from "./serverApi";
import busMixin from "./busMixin";

// const config = {
// 	test:1
// }
axios.get(`/api/getConfig`).then((res) => {
  console.log(res.data);
  config.init(res.data.config);
  // for(let key in res.data.config){
  // 	config[key] = res.data.config[key]
  // }
});

export function isEmail(string) {
  return /^[^@]+@[^@]+\.[^@]*\w+$/.test(string);
}

export function isTel(string) {
  return /^\d{2,3}-?\d{4}-?\d{4}$/.test(string);
}

export function getQuery(n) {
  var m = location.search.match(new RegExp("(\\?|&)" + n + "=([^&]*)(&|$)"));
  return !m ? "" : decodeURIComponent(m[2]);
}

export function getDict(num, value) {
  const lang = store.state.lang;

  let text = dict[lang][num] || "";
  if (value && Array.isArray(value)) {
    value.map((v, index) => {
      text = text.replace(RegExp(`\\$\\{\\s\*${index + 1}\\s\*\\}`, "g"), v);
    });
  }
  return text;
}

export function getPageDictInit(pageName) {
  let dict = pageDict[pageName];
  if (!dict) {
    throw new Error("no page dict");
  }
  return function(num, value) {
    const lang = store.state.lang;

    let text = dict[lang][num] || "";
    if (value && Array.isArray(value)) {
      value.map((v, index) => {
        text = text.replace(RegExp(`\\$\\{\\s\*${index + 1}\\s\*\\}`, "g"), v);
      });
    }
    return text;
  };
}

export function formatDate(dateValue, format = "YYYY/MM/DD HH:mm:ss") {
  let date = new Date(dateValue);
  return moment(date).format(format);
}

export function dateDuration(timeLength, format = "MM/DD HH:mm:ss") {
  let tempTime = moment.duration(timeLength);
  let seconds = tempTime.seconds();
  let minutes = tempTime.minutes();
  let hours = tempTime.hours();
  let days = tempTime.days();
  let months = tempTime.months();
  return format
    .replace(/MM/g, months)
    .replace(/DD/g, days)
    .replace(/HH/g, hours)
    .replace(/mm/g, minutes)
    .replace(/ss/g, seconds);
}
window.dateDuration = dateDuration;
export function isToday(dateValue) {
  let today = moment(new Date());
  let date = moment(dateValue);
  return today.isSame(date, "d");
}
window.isToday = isToday;

let interceptPathMap = {};
export async function interceptGet(path) {
  return new Promise((resolve, reject) => {
    if (interceptPathMap[path]) {
      interceptPathMap[path].push({ resolve, reject });
    } else {
      interceptPathMap[path] = [{ resolve, reject }];
      axios
        .get(path)
        .then((res) => {
          for (let item of interceptPathMap[path]) {
            item.resolve(res);
          }
          delete interceptPathMap[path];
        })
        .catch((e) => {
          for (let item of interceptPathMap[path]) {
            item.reject(e);
          }
          delete interceptPathMap[path];
        });
    }
  });
}

export const bus = new Vue();

export {
  invokeNative,
  axios,
  getPageLevelMixin,
  webSocket,
  moment,
  busMixin,
  config,
  serverApi,
};
